
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Hadapsartomumbaicabservice() {



    const cardData =
    {
        keyword: 'Hadapsar to Mumbai Cab Service',
        heading: 'Meghana Cab : Hadapsar to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Hadapsar to Mumbai Cab Service, ensuring a smooth, safe, and comfortable journey from Pune’s eastern hub to Mumbai. Whether you are planning an airport transfer, a corporate trip, or a weekend getaway, we provide well-maintained vehicles including Hatchbacks, Sedans, SUVs, Innova Crysta, and Tempo Travellers to suit your travel needs. Enjoy reliable door-to-door pickups from Hadapsar, professional drivers, transparent fares, and 24/7 customer support. Book your Hadapsar to Mumbai Cab with Meghana Cab today and experience stress-free intercity travel with punctual service and complete convenience.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
   
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Hadapsar to Mumbai Cab Booking",
        "description": "Book your taxi from Hadapsar to Mumbai with ease using our user-friendly platform. We provide prompt confirmation, well-maintained vehicles, and professional drivers to ensure a comfortable and stress-free journey."
    },
    {
        "name": "One Way Hadapsar to Mumbai Taxi",
        "description": "Our one-way taxi service from Hadapsar to Mumbai is perfect for airport transfers, business meetings, or personal travel. Enjoy punctual pickups and smooth rides tailored to your schedule."
    },
    {
        "name": "Round Trip Hadapsar to Mumbai Cab",
        "description": "Plan your round trip conveniently between Hadapsar and Mumbai with our flexible taxi service. Ideal for business travelers and tourists, we offer competitive pricing and reliable service for both legs of your journey."
    },
    {
        "name": "Online Cab Hire Hadapsar to Mumbai",
        "description": "Easily book your Hadapsar to Mumbai cab online with instant confirmation and multiple vehicle options. Our secure booking system guarantees transparency and convenience at your fingertips."
    },
    {
        "name": "Budget Cabs Hadapsar to Mumbai",
        "description": "Travel economically with our budget-friendly cabs from Hadapsar to Mumbai. We maintain clean and fuel-efficient vehicles to offer you the best value without compromising comfort or safety."
    },
    {
        "name": "AC Sedan Hadapsar to Mumbai",
        "description": "Ride in style and comfort with our air-conditioned sedan service from Hadapsar to Mumbai. Ideal for business or leisure travelers seeking a cool and smooth journey."
    },
    {
        "name": "SUV Taxi from Hadapsar to Mumbai",
        "description": "Need extra space for your luggage or group? Our spacious SUV taxis from Hadapsar to Mumbai provide ample room, comfort, and a smooth ride for families and groups."
    },
    {
        "name": "Reliable Hadapsar to Mumbai Cab",
        "description": "Count on our reliable taxi service from Hadapsar to Mumbai for timely pickups, professional drivers, and well-maintained vehicles, ensuring your trip is hassle-free and comfortable."
    },
    {
        "name": "Family Travel Cab Hadapsar to Mumbai",
        "description": "Make your family trip from Hadapsar to Mumbai safe and comfortable with our family-friendly cabs, featuring spacious seating, courteous drivers, and clean interiors."
    },
    {
        "name": "Chauffeur Driven Cab Hadapsar to Mumbai",
        "description": "Experience luxury and convenience with our chauffeur-driven cabs from Hadapsar to Mumbai. Our professional drivers prioritize your comfort, safety, and privacy."
    },
    {
        "name": "Fast Booking Hadapsar to Mumbai Taxi",
        "description": "In a hurry? Use our fast booking service to secure a taxi from Hadapsar to Mumbai quickly. We ensure prompt pickups and efficient routes for on-time arrivals."
    },
    {
        "name": "Long Drive Cab Hadapsar to Mumbai",
        "description": "Planning a long drive? Our cabs from Hadapsar to Mumbai are designed for comfort on longer routes, with well-maintained vehicles and experienced drivers to make your journey enjoyable."
    },
    {
        "name": "Private Taxi Hadapsar to Mumbai",
        "description": "Hire a private taxi for exclusive use from Hadapsar to Mumbai. Perfect for VIP travelers, families, or groups looking for privacy and personalized service throughout the trip."
    },
    {
        "name": "Business Trip Cab Hadapsar to Mumbai",
        "description": "Organize your corporate travel efficiently with our business trip cab service from Hadapsar to Mumbai. We offer timely pickups, professional conduct, and hassle-free billing tailored for business clients."
    },
    {
        "name": "24-Hour Cab Service Hadapsar to Mumbai",
        "description": "Our 24-hour taxi service from Hadapsar to Mumbai ensures you have reliable transport any time of the day or night, catering to early flights, late meetings, or urgent travel needs."
    }
],
"tableData": [
    ["Hadapsar to Mumbai Cab Booking", "One Way Hadapsar to Mumbai Taxi"],
    ["Round Trip Hadapsar to Mumbai Cab", "Online Cab Hire Hadapsar to Mumbai"],
    ["Budget Cabs Hadapsar to Mumbai", "AC Sedan Hadapsar to Mumbai"],
    ["SUV Taxi from Hadapsar to Mumbai", "Reliable Hadapsar to Mumbai Cab"],
    ["Family Travel Cab Hadapsar to Mumbai", "Chauffeur Driven Cab Hadapsar to Mumbai"],
    ["Fast Booking Hadapsar to Mumbai Taxi", "Long Drive Cab Hadapsar to Mumbai"],
    ["Private Taxi Hadapsar to Mumbai", "Business Trip Cab Hadapsar to Mumbai"],
    ["24-Hour Cab Service Hadapsar to Mumbai", ""]
],






"whychoose": [
    {
        "WhyChooseheading": "Reliable Hadapsar to Mumbai Cab Service",
        "WhyChoosedescription": "Our cab service from Hadapsar to Mumbai offers dependable, on-time pickups and smooth intercity travel. Whether you're heading to a business meeting, a family function, or the airport, we ensure your journey is stress-free and efficient."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and Air-Conditioned Cabs",
        "WhyChoosedescription": "Travel in comfort with our well-maintained vehicles equipped with clean interiors, proper air-conditioning, and spacious seating. Our fleet is designed to offer a relaxing ride, even during longer journeys between Hadapsar and Mumbai."
    },
    {
        "WhyChooseheading": "Trained and Verified Professional Drivers",
        "WhyChoosedescription": "Our drivers are licensed, experienced, and background-verified. They are courteous and well-acquainted with the Hadapsar–Mumbai route, ensuring safe driving, on-time arrivals, and a smooth overall experience."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "We provide straightforward pricing without any hidden costs. Your fare includes tolls, fuel, driver charges, and taxes, making it easy to budget your trip with full peace of mind and no surprise fees."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for All Travel Needs",
        "WhyChoosedescription": "Whether you need a one-way drop, a round trip, or hourly rental service, we offer flexible options to match your schedule. Customize your pickup and drop locations and travel times as per your preference."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop-off at Your Convenience",
        "WhyChoosedescription": "Our service includes pickup right from your doorstep in Hadapsar and drop-off at any location in Mumbai. Say goodbye to long walks or extra commutes—our cab comes to you wherever you are."
    },
    {
        "WhyChooseheading": "Ideal for Business Travel, Family Trips, and Airport Transfers",
        "WhyChoosedescription": "From corporate travel to personal visits and airport runs, our Hadapsar to Mumbai cab service is perfect for every occasion. We prioritize punctuality and comfort so you can focus on what matters."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Travel Assistance",
        "WhyChoosedescription": "Need help with a late-night booking or last-minute change? Our 24/7 customer support team is always available to assist you. We also provide real-time trip updates and emergency support during your ride."
    }
]























    }

const faqData = [
    {
        question: "How do I book a cab from Hadapsar to Mumbai with Meghana Cab?",
        answer: "You can book a cab by calling +91 9075462128 or through our website for easy and quick booking."
    },
    {
        question: "What is the typical travel time from Hadapsar to Mumbai by cab?",
        answer: "The journey usually takes about 3 to 4 hours, depending on traffic conditions."
    },
    {
        question: "Are both one way and round trip cab services available from Hadapsar to Mumbai?",
        answer: "Yes, we offer both one way and round trip options to fit your travel plans."
    },
    {
        question: "What types of vehicles can I choose for the Hadapsar to Mumbai route?",
        answer: "Our fleet includes hatchbacks, sedans, SUVs, and tempo travellers suitable for different group sizes."
    },
    {
        question: "Is the Hadapsar to Mumbai cab service available 24/7?",
        answer: "Yes, Meghana Cab provides 24/7 cab service to accommodate your schedule."
    },
    {
        question: "Does the fare include tolls, fuel, and driver charges?",
        answer: "Yes, the fare is all-inclusive covering fuel, tolls, and driver fees. Additional charges may apply for waiting or parking."
    },
    {
        question: "Can I book a cab from Hadapsar to Mumbai on short notice?",
        answer: "Yes, last-minute bookings are accepted depending on vehicle availability. Call us for urgent requests."
    },
    {
        question: "Is online booking available for the Hadapsar to Mumbai cab service?",
        answer: "Yes, you can book online anytime through our website with secure payment options."
    },
    {
        question: "Can I request stops for food or breaks during the trip?",
        answer: "Yes, stops can be arranged on request. Please notify us when booking or inform the driver."
    },
    {
        question: "Are the drivers experienced with the Hadapsar to Mumbai route?",
        answer: "Yes, our drivers are professional and well-versed with the best routes for a safe journey."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth and comfortable ride from Hadapsar to Mumbai. Driver was punctual and vehicle well maintained.”',
    },
    {
        name: 'Ms. Kavita Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service with hassle-free booking. Meghana Cab made my trip from Hadapsar to Mumbai very convenient.”',
    },
];






















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hadapsar to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/hadapsar-to-mumbai-cab.jpg",
  "description": "Book reliable and affordable cabs from Hadapsar to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and chauffeur-driven cars. Available for one-way and round trips with 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/hadapsar-to-mumbai-cab-service"
  }
};







    return (
        <div>
<Helmet>
  <title>Hadapsar to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Affordable and reliable cab service from Hadapsar to Mumbai by Meghana Cabs. Book AC Sedans, SUVs, or chauffeur-driven cars online. Available 24/7 for one-way and round trip travel." 
  />
  <meta 
    name="keywords" 
    content="Hadapsar to Mumbai Cab Booking, One Way Hadapsar to Mumbai Taxi, Round Trip Hadapsar to Mumbai Cab, Online Cab Hire Hadapsar to Mumbai, Budget Cabs Hadapsar to Mumbai, AC Sedan Hadapsar to Mumbai, SUV Taxi from Hadapsar to Mumbai, Reliable Hadapsar to Mumbai Cab, Family Travel Cab Hadapsar to Mumbai, Chauffeur Driven Cab Hadapsar to Mumbai, Fast Booking Hadapsar to Mumbai Taxi, Long Drive Cab Hadapsar to Mumbai, Private Taxi Hadapsar to Mumbai, Business Trip Cab Hadapsar to Mumbai, 24-Hour Cab Service Hadapsar to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/71.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Hadapsartomumbaicabservice;